import { render, staticRenderFns } from "./BlockType11List.vue?vue&type=template&id=50d762e4&scoped=true"
import script from "./BlockType11List.vue?vue&type=script&lang=ts"
export * from "./BlockType11List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType11List.vue?vue&type=style&index=0&id=50d762e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d762e4",
  null
  
)

export default component.exports